import Lenis from '@studio-freight/lenis';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// Cache pour la requête matchMedia
const isMobile = window.matchMedia("(max-width: 768px)");

export function init(wrapper = false) {
    if (isMobile.matches) return;

    const args = {
        smoothTouch: true,
        syncTouch: true,
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
    }

    if (wrapper) {
        args.wrapper = wrapper;
        disableScroll();
    } else {
        enableScroll();
    }

    this.lenis = new Lenis(args);

    // Optimisation des gestionnaires d'événements
    const updateScrollTrigger = () => ScrollTrigger.update();
    this.lenis.on('scroll', updateScrollTrigger);
    this.lenis.on('resize', updateScrollTrigger);

    // Optimisation du ticker
    const handleTicker = (time) => this.lenis?.raf(time * 1000);
    gsap.ticker.add(handleTicker);
    gsap.ticker.lagSmoothing(0);
}

export function destroy() {
    if (isMobile.matches || !this.lenis) return;
    this.lenis.destroy();
    this.lenis = null;
}

export function stop() {
    if (isMobile.matches || !this.lenis) return;
    this.lenis.stop();
}

export function start() {
    if (isMobile.matches || !this.lenis) return;
    this.lenis.start();
}

export function resize() {
    if (isMobile.matches || !this.lenis) return;
    this.lenis.resize();
}

export function disableScroll() {
    document.body.style.overflow = "hidden";
}

export function enableScroll() {
    document.body.style.overflow = "";
}

